import React, { useEffect, useState } from 'react';
import Footer from '../Components/footer';
import rasmohammed from '../Images/Routes/ras.jpg';
import wreck from '../Images/Routes/wreck.jpg';
import x1 from '../Images/Routes/5.jpg';
import x2 from '../Images/Routes/6.jpg';
import { Link, useNavigate } from "react-router-dom";
import Logo from "../Images/Home/boat.png";
import { onAuthStateChanged, signOut } from "firebase/auth";

export default function RoutesPage(props) {

    const [User, SetUser] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        onAuthStateChanged(props.auth, (user) => {
            if (user) {
                // User is signed in, see docs for a list of available properties
                // https://firebase.google.com/docs/reference/js/firebase.User
                SetUser(user);
                const uid = user.uid;
                // ...
                console.log("uid", uid)
            } else {
                // User is signed out
                // ...
                console.log("user is logged out")
            }
        });
    }, [])

    function signout() {
        signOut(props.auth).then(() => {
            window.location.reload(false);
            // Sign-out successful.
        }).catch((error) => {
            // An error happened.
        });
    }

    return (
        <div className="routesbody">
            <nav className="navbar navbar-expand-lg navbar-dark nav-bg fixed-top">
                <div className="container-fluid">
                    <Link to="/" className="navbar-brand"><img src={Logo} alt="Logo" width="30" height="30" /></Link>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 navbar-nav-scroll">
                            <li className="nav-item">
                                <Link to="/" className="nav-link" aria-current="page">Home</Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    Boats
                                </a>
                                <ul className="dropdown-menu">
                                    <li><Link to="/cechoii" className="dropdown-item">C-ECHO II</Link></li>
                                    <li><Link to="/nimar" className="dropdown-item">Nimar</Link></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <Link to="/routes" className="nav-link active">Routes</Link>
                            </li>
                            <li className="nav-item">
                                <Link to="/news" className="nav-link">News</Link>
                                </li>
                            {User !== '' ? <li className="nav-item">
                                <Link to="/contact" className="nav-link ">Book a boat</Link>
                            </li> : null}
                        </ul>
                        <ul className="navbar-nav navbar-nav-scroll">
                            {User !== '' ? <li className="nav-item">
                                <Link to="/bookings" className="nav-link">Bookings</Link>
                            </li> : null}
                            <li className="nav-item">
                                {User === '' ? <Link to="/login" className="nav-link">Login</Link> : null}
                            </li>
                            <li className="nav-item">
                                {User === '' ? <Link to="/signup" className="nav-link">Register</Link> : null}
                            </li>
                            <li>
                                {User !== '' ? <Link to="/" className="nav-link" onClick={signout}>Logout</Link> : null}
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <section style={{ textAlign: 'center' }}>
                <h2 className='text-white' style={{ paddingTop: '5rem', fontSize: '60px' }}>Routes</h2>
                <div className="container px-4 px-lg-5 pb-4 text-white">
                    <div className="row gx-4 gx-lg-5">
                        <div className="col-lg-12">
                            <h1 className="mt-5">The best  diving routes in the Red Sea.</h1>
                            <br />
                            <p>The Red sea is one of the best destinations for divers in the world, it contains several of diving points that provide you with many programmes during your trip, coral reefs cover an area of 2000 kms and are considered from international natural heritage.</p>
                            <p>In fact different kinds of animals and plants species of the red sea became famous all over the world , the red sea area is suitable place  to dive compared with other areas this surprising area includes 1000 kinds of fish and 150 kinds of coral reefs BWS has chosen the best routes and diving points to enjoy in the red sea area. </p>
                        </div>
                    </div>
                </div>
            </section>
            <section className="sectionL">
                <div className="container px-4 px-lg-5 py-5">
                    <div className="row gx-4 gx-lg-5">
                        <div className="col-lg-6">
                            <h1 className="mt-5 py-3 text-black">NORTH CLASSIC</h1>
                            <p>There is no doubt that's the star route in Red-Sea, its one of the most common places and demanded routes in  Egypt. if you want an awesome route in Egypt it’s the one for you, in it you can discover world-famous dives and a wonderful live boat cruises, this place is for all levels, the several of different dives make this route one of the most awesome and special all over Egypt, you can enjoy all virtues like reef and the amazing ally’s of coral, you will enjoy with dreamlike landscapes and historical wrecks too like Sinai peninsula and all islands with their amazing lagoons and reefs also with our visit to Gubal and its awesome colors you will be filled with joy.</p>
                        </div>
                        <div className="col-lg-6 imc-hover" style={{ paddingLeft: '10px' }}>
                            <img src={rasmohammed} width="100%" height="100%" alt="ras mohammed" />
                            <a href="contact.html"><button className="imc-text buttonBook">Book now</button></a>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container px-4 px-lg-5 py-4 text-white">
                    <div className="container px-4 px-lg-5 py-5">
                        <div className="row gx-4 gx-lg-5">
                            <div className="col-lg-6 imc-hover" style={{ paddingLeft: '10px' }}>
                                <img src={x2} width="100%" height="100%" alt="north and brothers" />
                                <a href="contact.html"><button className="imc-text buttonBook">Book now</button></a>
                            </div>
                            <div className="col-lg-6">
                                <h1 className="mt-5 py-3">NORTH + BROTHERS</h1>
                                <p>This Route is the most desired route by our customers because of the variety dives and its considered one of the best combinations and its dives are different from each other you can recognize the environment like pelagic life, the spectacular of historical wrecks and reef we will visit Ras Mohamed National park to enjoy under water Paradise we immerse ourselves in the SS Thistlegorm and explore Abu Nuhas reef.
                                    We will sail to the Brothers islands, which located in the middle of red sea we will also immerse ourselves in the wrecks Numidia and Ada we will be back to Hurghada to visit the Salem if the weather will be favorable.</p>
                            </div>
                        </div>
                    </div>
                </div></section>
            <section style={{ backgroundColor: 'aliceblue' }}>
                <div className="container px-4 px-lg-5 py-5">
                    <div className="row gx-4 gx-lg-5">
                        <div className="col-lg-6">
                            <h1 className="mt-5 py-3 text-black">WRECKS</h1>
                            <p>Since the opening of the Suez Canal in 1869, the red sea inevitably became a most desirable step for all traders and navigators in the world deporting. From Hurghada we will dive to the Abu Nuhas reef where the wrecks Giannis D Carnatic, krisoula and kimon M all of these are located on the Northern slope. We alternate the best wrecks of the whole north of the red sea with the most spectacular dives alongside with Gubal and North. We will dive into modern history by diving in wrecks during the World War 2 SS Thistlegorm and Rosalie Moller. We will sail to Safaga to immerse ourselves in the Salem passageway. The ferry that sank in 1991 with pilgrims returning from mecca with catastrophic consequences alongside with Gubal we will visit the Ulysses Dunraven and Kingstone.</p>
                        </div>
                        <div className="col-lg-6 imc-hover" style={{ paddingLeft: '10px' }}>
                            <img src={wreck} width="100%" height="100%" alt="wreck" />
                            <a href="contact.html"><button className="imc-text buttonBook">Book now</button></a>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container px-4 px-lg-5 py-4 text-white">
                    <div className="container px-4 px-lg-5 py-5">
                        <div className="row gx-4 gx-lg-5">
                            <div className="col-lg-6 imc-hover" style={{ paddingLeft: '10px' }}>
                                <img src={x1} width="100%" height="100%" alt="GREAT SOUTH" style={{ objectFit: 'cover' }} />
                                <button className="imc-text buttonBook">Book now</button>
                            </div>
                            <div className="col-lg-6">
                                <h1 className="mt-5 py-3">GREAT SOUTH</h1>
                                <p>The great southern route has great distance navigation between areas. 
                                    You can explore all different types of diving in it and you can also see an exclusive place there and all of this thanks to safari boats 
                                    because they’re the only method allows you to see these beautiful dives. The great southern route is one of the most wonderful routes 
                                    which has many and various environmental resources, 
                                    it also has famous dive spots like dolphin reef where we can snorkel with these free mammals or the St. 
                                    Thanos reef chain.
                                    </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    );
}